module.exports = __webpack_public_path__ + "static/media/Hoss Head 1.62cb6f7e.svg";